var helper = {

    /*
     * usage :
     * return DOM element
     */
    context: (name) => {
        try {
            return document.querySelector(`[${name}]`);
        } catch (e) {
            console.log(e, name);
        }

        return null;
    },

    /*
     * usage :
     * return -
     */
    event: (element, events, listener) => {
        var event = events.split(' ');
        for (var i = 0, iLen = event.length; i < iLen; i++) {
            element.addEventListener(event[i], listener, false);
        }
    },

    /*
     * usage :
     * return DOM element
     */
    element: (name, all = false) => {
        try {
            let elm = null;
            if (name.substring(0, 1) === ".") {
                elm = document.getElementsByClassName(name.substring(1));
            } else if (name.substring(0, 1) === "#") {
                elm = document.getElementById(name.substring(1));
            } else {
                elm = document.getElementsByTagName(name);
                if (elm.length === 0) {
                    if (all) {
                        elm = document.querySelectorAll(name);
                    } else {
                        elm = document.querySelector(name);
                    }

                }
            }
            if (elm && elm.length > 0) {
                return all ? elm : elm[0];
            } else {
                return elm;
            }
        } catch (e) {
            console.log(document, name, e);
        }

        return null;
    },

    /*
     * usage :
     * return true/false
     */
    validate: function (fields, checkall = false, show = true) {
        let success = true;
        Object.values(fields).forEach(function (item, k) {
            if (item.classList.contains("js-required")) {
                let pattern = new RegExp(item.getAttribute("pattern"));
                if ((item.value.trim() === "" || (item.getAttribute("pattern") !== null) ? !pattern.test(item.value.trim()) : false) && item.getAttribute("type") !== "radio") {
                    success = false;
                    if (show) {
                        item.classList.add("error");
                        item.classList.remove("validated");
                    }
                } else {
                    item.classList.remove("error");
                    item.classList.add("validated");
                }

                if (item.getAttribute("type") === "radio") {

                    const c = document.querySelector(`input[name="${item.name}"]:checked`);
                    const group = helper.element(`.js-group-${item.name}`, false);
                    if (c !== null) {
                        group.classList.remove("error");
                        group.classList.add("validated");
                    } else {
                        success = false;
                        if (show) {
                            group.classList.add("error");
                            group.classList.remove("validated");
                        }
                    }
                }
            }
        });

        return success;
    },

    /*
     * usage :
     * delay(0.5).then(function() {   });
     *
     * return -
     */
    delay: (duration) => {
        return new Promise(resolve => setTimeout(resolve, duration));
    }
}
